var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 8.00028C15.9989 12.0408 13.0039 15.3811 9.11323 15.9232C8.74944 15.9737 8.37724 16 7.99944 16C7.56334 16 7.13509 15.9652 6.71805 15.898C2.90919 15.2847 0 11.9819 0 8.00028C0 3.58196 3.58184 0 8 0C12.4182 0 16 3.58196 16 8.00028H15.9989Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24442 3.53125L6.93388 8.46416L3.22144 12.4749H4.0572L7.30776 8.96361L9.93388 12.4749H12.7775L8.88063 7.26456L12.3363 3.53125H11.5006L8.50731 6.76511L6.08859 3.53125H3.24497H3.24442ZM4.47311 4.14674H5.77917L11.5477 11.8595H10.2416L4.47311 4.14674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFTwitter);
export default __webpack_public_path__ + "static/media/f-twitter.6de1857ae8f270da2cfb468fe76138b8.svg";
export { ForwardRef as ReactComponent };